<template>
  <component
    :is="componentName"
    :id="playerModel._id"
    :type="playerModel._type"
    :verified="playerModel.approved || playerModel.verified"
    class="d-flex flex-grow-0 flex-shrink-0 flex-column align-items-center text-light text-center battle-account"
  >
    <span class="position-relative d-block">
      <span
        class="battle-account_avatar-border d-block"
        :class="{ 'winner shape-mask': isWinner }"
      >
        <Avatar
          :size="size"
          :img-url="playerModel && playerModel._avatar"
          :type="playerModel._type"
          class="players-item-avatar"
          :highlighted="isWinner"
        />
      </span>
      <TextBlock
        v-if="isWinner"
        text="Winner"
        :size="0.8"
        :line-height="2"
        class="position-absolute battle-account_winner-label"
      />
    </span>
    <TextBlock
      :text="playerName"
      class="text-truncate mw-100 mt-3"
      :class="{ 'pt-2': !isWinner }"
    />
    <TextBlock
      :text="playerRole"
      :size="0.8"
      variant="secondary"
      class="mt-3"
    />
  </component>
</template>

<script>
import { translate } from '@/mixins/translate';
import Avatar from '@/components/images/Avatar';
import LinkAccount from '@/components/links/Account';
import TextBlock from '@/components/atoms/TextBlock';
import AccountModel from '@/models/Account';

export default {
  name: 'BattleAccount',
  components: {
    Avatar,
    TextBlock,
    LinkAccount,
  },
  mixins: [translate('_web_battle-account')],
  props: {
    size: {
      type: Number,
      default: 84,
    },
    host: {
      type: Boolean,
      default: false,
    },
    player: {
      type: Object,
      required: true,
    },
    isWinner: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    playerModel() {
      return this.player.isModel || this.$lodash.isEmpty(this.player)
        ? this.player
        : new AccountModel(
            this.player.type,
            this.player.id || this.player.login
          ).update(this.player);
    },
    isEmpty() {
      return this.$lodash.isEmpty(this.player);
    },
    componentName() {
      return this.isEmpty ? 'div' : 'LinkAccount';
    },
    playerName() {
      return this.isEmpty
        ? this.$$t('Empty')
        : this.$filters.displayName(this.player);
    },
    playerRole() {
      return this.host ? this.$$t('Host') : this.$$t('Guest');
    },
  },
};
</script>

<style lang="scss">
.battle-account {
  max-width: 40%;
  flex-basis: 40%;
  &_avatar-border.winner {
    padding: 2px;
    @include primary-background-gradient(230deg);
  }
  &_winner-label {
    $height: 1.5rem;
    bottom: -2px;
    right: -2px;
    left: -2px;
    height: $height;
    border-radius: math.div($height, 2);
    vertical-align: middle;
    @include primary-background-gradient(170deg);
  }
}
</style>
